import {Container, Graphics, Filter} from "pixi.js";

class ConnectionsLayer {
    constructor(options) {
        const defaultOptions = {
            minDots: 30,
            maxDots: 130,
            minDistance: 0.0025,
            maxDistance: 0.15,
            yOffsetMin: -0.3,
            yOffsetMax: 0.1,
            baseline: "wave",
            color: "#ffffff",
            topOffset: 0,
            limitTop: false,
            lineWidth: 1,
            blur: false,
            alpha: 1
        };

        this.options = { ...defaultOptions, ...options };

        this.color = '0x' + this.options.color.replace('#', '');

        this.el = options.el;

        // this.width = this.options.blur ? this.options.width * 1.5 : this.options.width;
        // this.height = this.options.blur ? this.options.height * 1.5 : this.options.height;

        // width and height should be divided by two because of the blur
        this.width = Math.ceil(this.options.width / 2) * 2;
        this.height = Math.ceil(this.options.height / 2) * 2;

        this.dots = [];
        this.connections = [];
        this.container = new Container();
        // this.container.width = this.width;
        // this.container.height = this.height;
        // this.container.x = 0;
        // this.container.y = 0;
        options.app.stage.addChild(this.container);
        this.graphics = new Graphics();
        // this.graphics.width = this.width;
        // this.graphics.height = this.height;
        // this.graphics.x = 0;
        // this.graphics.y = 0;
        this.container.addChild(this.graphics);
        if(this.options.blur) {

            const blurShader = `
precision mediump float;

varying vec2 vTextureCoord;
uniform vec3 size; // width, height, radius
uniform sampler2D uSampler;

const int Quality = 8;
const int Directions = 16;
const float Pi = 6.28318530718; // pi * 2

void main()
{
    vec2 radius = size.z / size.xy;
    vec4 color = texture2D(uSampler, vTextureCoord);

    for(float d = 0.0; d < Pi; d += Pi / float(Directions))
    {
        for(float i = 1.0 / float(Quality); i <= 1.0; i += 1.0 / float(Quality))
        {
            color += texture2D(uSampler, vTextureCoord + vec2(cos(d), sin(d)) * radius * i);
        }
    }

    color /= float(Quality) * float(Directions) + 1.0;

    gl_FragColor = color;
}
`;

            this.customBlurFilter = new Filter(undefined, blurShader, {
                size: [this.width, this.height, 10.0],
            });

            // this.blurFilter = new filters.BlurFilter();
            // this.blurFilter.quality = 20;
            // this.blurFilter.blur = 20;
            this.container.filters = [this.customBlurFilter];
        }

        if(this.options.alpha !== 1) {
            this.container.alpha = this.options.alpha;
        }

        this.generateDots();
        this.connectDots();
    }

    handleResize(width, height) {
        // this.width = this.options.blur ? width * 1.5 : width;
        // this.height = this.options.blur ? height * 1.5 : height;

        // this.width = width;
        // this.height = height;

        this.width = Math.ceil(width / 2) * 2;
        this.height = Math.ceil(height / 2) * 2;

        // this.container.width = this.width;
        // this.container.height = this.height;
        // this.graphics.width = this.width;
        // this.graphics.height = this.height;

        this.recalculateDots();
        if(this.options.blur && this.customBlurFilter) {
            this.customBlurFilter.uniforms.size = [this.width, this.height, 10.0];
        }
    }

    recalculateDots() {
        // for (let i = 0; i < this.dots.length; i++) {
        //     const t = i / (this.dots.length - 1);
        //     this.dots[i].initialX = t * this.width;
        // }
        // clear dots
        this.dots = [];
        this.generateDots();
        this.connectDots();
    }

    calculateNumDots() {
        const minWidth = 320; // minimum screen width
        const maxWidth = 1440; // maximum screen width

        if (this.width <= minWidth) {
            return this.options.minDots;
        } else if (this.width >= maxWidth) {
            return this.options.maxDots;
        } else {
            const t = (this.width - minWidth) / (maxWidth - minWidth);
            return Math.round(this.options.minDots + t * (this.options.maxDots - this.options.minDots));
        }
    }

    generateDots() {
        this.numDots = this.calculateNumDots();
        for (let i = 0; i < this.numDots; i++) {
            const t = i / (this.numDots - 1);
            const x = t * this.width;
            const screenWidth = window.innerWidth;

            let angle;

            switch (this.options.baseline) {
                case "wave":
                    if (screenWidth < 768) {
                        angle = Math.PI / 2 + t * Math.PI * 1.1;
                    } else {
                        angle = Math.PI / 2 + t * Math.PI * 1.5;
                    }
                    break;
                case "line2":
                    angle = Math.PI * 7 + t * Math.PI - t / 2;
                    break;
                case "parabola":
                    // U-shaped parabola
                    angle = 4 * t * t + t - 2;
                    break;
                default:
                    angle = Math.PI / 2 + t * Math.PI;
                    break;
            }

            let y, yOffset;

            if(this.options.baseline === "parabola") {
                yOffset = (Math.random() * (this.options.yOffsetMax - this.options.yOffsetMin) + this.options.yOffsetMin) * this.height;
                y = Math.sin((.25 * Math.PI * x) / 300) * this.height / 2 + this.height / 2 + yOffset * .8 + this.options.topOffset * this.height;
            } else {
                yOffset = (Math.random() * (this.options.yOffsetMax - this.options.yOffsetMin) + this.options.yOffsetMin) * this.height;
                y = 0.5 * Math.cos(angle) * this.height / 2 + this.height / 2 + yOffset + this.options.topOffset * this.height;
            }

            // console.log(x, y);
            const radius = (2 + 7 * Math.pow(Math.random(), 2));
            const speedFactor = ((15 - radius) / 10);
            const speedX = speedFactor * (0.0002 + Math.random() * 0.0005);
            const speedY = speedFactor * (0.0002 + Math.random() * 0.0005);
            const accelerationX = speedFactor * (0.0002 + Math.random() * 0.0025);
            const accelerationY = speedFactor * (0.0002 + Math.random() * 0.0025);
            const angleOffset = Math.random() * 2 * Math.PI;
            const movementType = ['circle', 'ellipse', 'spiral', 'figureEight'][Math.floor(Math.random() * 4)];
            this.dots.push({ x, y, radius, speedX, accelerationX, accelerationY, speedY, yOffset, initialY: y, initialX: x, angleOffset, movementType });
        }
    }

    connectDots() {
        this.connections = [];
        this.dots.forEach((dot1, indexA) => {
            const availableDots = this.dots;
            let connectionCount = 0;

            availableDots.forEach((dot2, indexB) => {
                const distance = Math.sqrt(Math.pow(dot1.x - dot2.x, 2) + Math.pow(dot1.y - dot2.y, 2));
                const minDistance = this.options.minDistance * this.height;
                const maxDistance = this.options.maxDistance * this.height;
                if (distance >= minDistance && distance <= maxDistance) {
                    let alreadyConnected = false;
                    this.connections.forEach((connection) => {
                        if ((connection.dot1 === dot1 && connection.dot2 === dot2) || (connection.dot1 === dot2 && connection.dot2 === dot1)) {
                            alreadyConnected = true;
                        }
                    })
                    if (!alreadyConnected) {
                        this.connections.push({ dot1, dot2 });
                        connectionCount++;
                    }
                }
            });
            if(connectionCount === 0) {
                let findClosestDot = false;
                let tries = 0;
                while (!findClosestDot && tries < 20) {
                    let closestDot = null;
                    let closestDistance = 999999999;
                    availableDots.forEach((dot2, indexB) => {
                        const distance = Math.sqrt(Math.pow(dot1.x - dot2.x, 2) + Math.pow(dot1.y - dot2.y, 2));
                        if (distance < closestDistance) {
                            closestDistance = distance;
                            closestDot = dot2;
                        }
                    })
                    let alreadyConnected = false;
                    this.connections.forEach((connection) => {
                        if ((connection.dot1 === dot1 && connection.dot2 === closestDot) || (connection.dot1 === closestDot && connection.dot2 === dot1)) {
                            alreadyConnected = true;
                        }
                    })
                    if (!alreadyConnected) {
                        this.connections.push({dot1, dot2: closestDot});
                        findClosestDot = true;
                    }
                    tries++;
                }
            }

            if (connectionCount === 0 && indexA < this.dots.length - 1) {
                this.connections.push({ dot1, dot2: this.dots[indexA + 1] });
            }
        });
    }

    drawConnections() {
        this.connections.forEach((connection) => {
            this.drawLine(connection.dot1, connection.dot2);
        });
    }

    drawLine(dot1, dot2) {
        this.graphics.lineStyle(this.options.lineWidth, this.color);
        this.graphics.moveTo(dot1.x, dot1.y);
        this.graphics.lineTo(dot2.x, dot2.y);
    }

    drawDots() {
        this.dots.forEach((dot) => {
            this.drawDot(dot);
        });
    }

    drawDot(dot) {
        this.graphics.beginFill(this.color);
        this.graphics.drawCircle(dot.x, dot.y, dot.radius);
        this.graphics.endFill();
    }

    animate() {
        if(this.width > 0) {
            this.dots.forEach((dot) => {
                let movementX, movementY;

                switch (dot.movementType) {
                    case 'circle':
                        movementX = Math.sin(dot.speedX + dot.angleOffset) * 30;
                        movementY = Math.cos(dot.speedY + dot.angleOffset) * 30;
                        break;
                    case 'ellipse':
                        movementX = Math.sin(dot.speedX + dot.angleOffset) * 30;
                        movementY = Math.cos(dot.speedY * 2 + dot.angleOffset) * 15;
                        break;
                    case 'spiral':
                        movementX = Math.sin(dot.speedX + dot.angleOffset) * (30 - 0.1 * dot.speedX);
                        movementY = Math.cos(dot.speedY + dot.angleOffset) * (30 - 0.1 * dot.speedY);
                        break;
                    case 'figureEight':
                        movementX = Math.sin(dot.speedX + dot.angleOffset) * 30;
                        movementY = Math.cos(dot.speedX * 2 + dot.angleOffset) * 15;
                        break;
                }

                dot.x = dot.initialX + movementX;
                dot.y = dot.initialY + movementY;

                if(dot.limitTop && dot.y + dot.radius < 0) {
                    dot.y = dot.radius;
                }

                dot.speedY += dot.accelerationY;
                dot.speedX += dot.accelerationX;
            });
            this.graphics.clear();
            this.drawDots();
            this.drawConnections();
        }
    }
}

export default ConnectionsLayer;
